import PropTypes from "prop-types";
import React, { Component } from "react";
import { Radio, RadioGroup } from "@blueprintjs/core";
import FileUpload from "../../../common/FileUpload";
import RightPanel from "../../../common/RightPanel";
import styles from "../../../../styles/UploadCsv.module.scss";
import styleRedio from "../../../../styles/SelectByIdPanel.module.scss";
import { ShowMatchedResults } from "../../../common/SelectByIdPanel";

export default class UploadScreensCSV extends Component {
  state = {
    uploadErrors: [],
    hasUploadError: false,
    isLoading: false,
    selectionTypes: [
      { value: "inclusions", label: "Inclusions" },
      { value: "exclusions", label: "Exclusions" },
    ],
  };

  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    header: PropTypes.string,
    title: PropTypes.string,
    primaryButtonProps: PropTypes.object,
    uploadCSVFile: PropTypes.func.isRequired,
    matchedTheatreData: PropTypes.array,
    unmatchedTheatreData: PropTypes.array,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen && !this.props.isOpen) {
      this.clearErrors();
    }
  }

  clearErrors = () => {
    this.setState({
      uploadErrors: [],
      hasUploadError: false,
    });
  };

  handleFormCancel = () => {
    this.props.onClose();
    this.clearErrors();
  };

  handleFileSelect = (file) => {
    this.setState({ isLoading: true });
    this.props
      .uploadCSVFile(file)
      .then(() => {
        this.setState({ isLoading: false });
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  };

  render() {
    const {
      isOpen,
      header,
      title,
      primaryButtonProps,
      secondaryButtonProps,
      matchedTheatreData,
      unmatchedTheatreData,
      handleSelectionTypeChange,
      selectionType,
    } = this.props;
    const { isLoading, selectionTypes } = this.state;

    // Filter unique matched theatre data based on screen_id using set
    const seenScreenIds = new Set();
    const uniqueMatchedData = matchedTheatreData.filter((item) => {
      const screenId = item.request.screen_id;
      if (seenScreenIds.has(screenId)) {
        return false;
      }
      seenScreenIds.add(screenId);
      return true;
    });
    const matchedCount = uniqueMatchedData.length;
    const unmatchedCount = unmatchedTheatreData.length;

    // Check if any matched data are screens
    const hasMatchedScreen = matchedTheatreData.some((data) => data.request.screen_id);

    // Check if any unmatched data are screens or theatres
    const hasUnmatchedScreen = unmatchedTheatreData.some((data) => data.request.screen_id);
    const hasUnmatchedTheatre = unmatchedTheatreData.some((data) => data.request.id);

    return (
      <RightPanel
        isOpen={isOpen}
        onClose={this.handleFormCancel}
        header={header}
        showFooter={true}
        primaryButtonProps={primaryButtonProps}
        secondaryButtonProps={secondaryButtonProps}
      >
        <label className={styleRedio.criteriaTypeLabel}>Add to</label>
        <RadioGroup
          className={styleRedio.criteriaTypeRadioGroup}
          onChange={(v) =>
            handleSelectionTypeChange(selectionTypes.find((t) => t.value === v.target.value).value)
          }
          selectedValue={selectionType}
          inline
        >
          {selectionTypes.map((t) => (
            <Radio key={t.value} value={t.value} label={t.label} />
          ))}
        </RadioGroup>
        <FileUpload
          title={title}
          description="(or) Drag & drop CSV"
          errorMessage="Please upload a CSV file"
          icon="DownloadIcon"
          onSelect={this.handleFileSelect}
          acceptableFormats=".csv"
          mimeType={[
            "text/csv",
            "application/csv",
            "text/plain",
            "application/vnd.ms-excel",
            "text/comma-separated-values",
          ]}
          uploadingMessage="Verifying screens"
          isLoading={isLoading}
        />
        {isLoading ? (
          <div className={styles.loadingContainer}>Loading...</div>
        ) : (
          <div className={styles.uploadedFileContainer}>
            <ShowMatchedResults
              matchedCount={matchedCount}
              hasMatchedScreen={hasMatchedScreen}
              unmatchedCount={unmatchedCount}
              hasUnmatchedScreen={hasUnmatchedScreen}
              hasUnmatchedTheatre={hasUnmatchedTheatre}
              unmatchedTheatreData={unmatchedTheatreData}
            />
          </div>
        )}
      </RightPanel>
    );
  }
}
